/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { GetApiDonationsByUserIdQueryResponse, GetApiDonationsByUserIdPathParams, GetApiDonationsByUserId400, GetApiDonationsByUserId401, GetApiDonationsByUserId403, GetApiDonationsByUserId500 } from "../../types/GetApiDonationsByUserId.ts";
import { getApiDonationsByUserIdQueryResponseSchema } from "../../zod/AdminPaymentsSchemas/getApiDonationsByUserIdSchema.ts";

function getGetApiDonationsByUserIdUrl({ id }: { id: GetApiDonationsByUserIdPathParams["Id"] }) {
  const res = { method: 'GET', url: `/api/donations/by-user/${id}` as const }  
  return res
}

/**
 * @summary Получить список платежей по пользователям
 * {@link /api/donations/by-user/:Id}
 */
export async function getApiDonationsByUserId({ id }: { id: GetApiDonationsByUserIdPathParams["Id"] }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetApiDonationsByUserIdQueryResponse, ResponseErrorConfig<GetApiDonationsByUserId400 | GetApiDonationsByUserId401 | GetApiDonationsByUserId403 | GetApiDonationsByUserId500>, unknown>({ method : "GET", url : getGetApiDonationsByUserIdUrl({ id }).url.toString(), ... requestConfig })  
  return getApiDonationsByUserIdQueryResponseSchema.parse(res.data)
}